import styled from 'styled-components'

import { BREAKPOINT } from '../design/breakpoint.constant'

const WaypointsMapContainer = styled.div`
  display: flex;
  height: 390px;

  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    height: 512px;
  }
`

export { WaypointsMapContainer }
